import { useMixpanelUser } from './_hooks';

const MixpanelUserProvider = ({ children }) => {
  useMixpanelUser();
  return children;
};

export default MixpanelUserProvider;
